"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const SuccessResponse_1 = __importDefault(require("../../Domain/SuccessResponse"));
const domain_shared_1 = require("@shared/domain-shared");
const defaultHeaders = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
};
class Fetch {
    constructor() {
        //
    }
    get(url, params = {}, headers = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const urlParams = params ? '?' + new URLSearchParams(params).toString() : '';
            const result = yield fetch(`${url}${urlParams}`, {
                method: 'GET',
                headers: Object.assign({}, defaultHeaders, headers),
            });
            return this.makeResponse(result);
        });
    }
    post(url, params = {}, headers = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const fetchHeaders = Object.assign({}, defaultHeaders, headers);
            const body = this.prepareParams(params, fetchHeaders['Content-Type']);
            const result = yield fetch(`${url}`, {
                method: 'POST',
                body: body,
                headers: fetchHeaders,
            });
            return this.makeResponse(result);
        });
    }
    delete(url, headers = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield fetch(url, {
                method: 'DELETE',
                headers: Object.assign({}, defaultHeaders, headers),
            });
            return this.makeResponse(result);
        });
    }
    makeResponse(response) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (response.ok === false) {
                if (response.headers.get('content-type') === 'application/problem+json') {
                    const problemDetails = yield response.json();
                    const error = domain_shared_1.CademyError.fromObject(problemDetails);
                    throw error;
                }
                if (response.headers.get('content-type') === 'application/json') {
                    const errorDetails = yield response.json();
                    throw new domain_shared_1.AwSnap((_a = errorDetails.title) !== null && _a !== void 0 ? _a : errorDetails.safe);
                }
                throw new domain_shared_1.AwSnap();
            }
            const responseBody = yield response.json();
            return new SuccessResponse_1.default(response.status, responseBody);
        });
    }
    prepareParams(params, contentType) {
        switch (contentType) {
            case 'application/x-www-form-urlencoded':
                return new URLSearchParams(params).toString();
            case 'application/json':
            default:
                return JSON.stringify(params);
        }
    }
}
exports.default = Fetch;
